import React, { createContext ,useState} from 'react'
import { useEffect } from 'react';
// import all_product from "../Components/Assets/all_product";


export const  ShopContext= createContext(null);
// let cart={};
// for(let index=0;index<all_product.length;index++)
//     {
//        cart[index]=0;
//              }
//              return cart;}
            
const getDefaultCart=()=>{
    
     let cart={};
     
     for(let index=1;index<=300;index++)
         {
            cart[index]=0;
                  }
                  return cart;}
    
const ShopContextProvider=(props)=>{

const[all_product,setAll_Product]=useState([]);

    const [cartItems,setCartItems]=useState(getDefaultCart());
    



useEffect(()=>{




        fetch('https://sarathi-0cyh.onrender.com/allproducts')
            .then((response) => {
                if (!response.ok) throw new Error(response.statusText);
                return response.json();
            })
            .then((data) => setAll_Product(data))
            .catch((err) => {
                console.error('Failed to fetch all products:', err);
                setAll_Product([]);
            });


if(localStorage.getItem('auth-token')){
        fetch('https://sarathi-0cyh.onrender.com/getcart',{
        method:'POST',
        headers:{
            'Accept':'application/json',
            'auth-token':`${localStorage.getItem('auth-token')}`,
            'Content-type':'application/json'
       
        },
        body:"",
        })
        .then((response) => {
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
        })
        .then((data) => setCartItems(data))
        .catch((err) => {
            console.error('Failed to fetch cart:', err);
        });
}
    },[])









const addToCart=(itemId)=>{
setCartItems((prev)=>({...prev,[itemId]:prev[itemId]+1}))

// console.log(cartItems);
if(localStorage.getItem('auth-token')){
        fetch('https://sarathi-0cyh.onrender.com/addtocart',{
                method:'POST',
                headers:{
                             'Accept': 'application/json',
                        'auth-token':`${localStorage.getItem('auth-token')}`
,
        'Content-Type':'application/json',
                },
                body:JSON.stringify({"itemId":itemId}),
        })
        .then((response) => {
            if (!response.ok) throw new Error(response.statusText);
            return response.text();
        })
        .then((data)=>console.log(data))
        .catch((err)=>{
            console.error('Failed to add to cart:', err);
        })
}


}
const removeFromCart=(itemId)=>{
    setCartItems((prev)=>({...prev,[itemId]:prev[itemId]-1}))
   

    if(localStorage.getItem('auth-token')){
                fetch('https://sarathi-0cyh.onrender.com/removefromcart',{
                        method:'POST',
                        headers:{
                                     'Accept': 'application/json',
                                'auth-token':`${localStorage.getItem('auth-token')}`
        ,
        'Content-Type':'application/json',
                        },
                        body:JSON.stringify({"itemId":itemId}),
                })
                .then((response) => {
                    if (!response.ok) throw new Error(response.statusText);
                    return response.text();
                })
                .then((data)=>console.log(data))
                .catch((err)=>{
                    console.error('Failed to remove from cart:', err);
                })
    }
    
    



}


const getTotalCartAmount=()=>{
    let totalAmount=0;
    for(const item in cartItems)
    {
if(cartItems[item]>0)
{
    let itemInfo=all_product.find((product)=>product.id===Number(item))
    totalAmount+=itemInfo.new_price*cartItems[item];
}

    }
    return totalAmount;
}
const getTotalCartItems=()=>{
    let totalItem=0;
    for(const item in cartItems)
    {
        if(cartItems[item]>0)
        {
            totalItem+=cartItems[item];
        }
    }
    return totalItem;
}





    const contextValue={getTotalCartItems,getTotalCartAmount,all_product,cartItems,addToCart,removeFromCart};

    
    return (
        <ShopContext.Provider value={contextValue}>
            {props.children}
            </ShopContext.Provider>
      
    )
}
export default ShopContextProvider;